import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';

const catalogTagsBatchCreateConfig: JsonRestApiRequestConfig = {
  restApiVersion: '3.9',
  serverWideRequest: false,
  httpMethod: 'PUT',
  endpoint: 'tags:batchCreate'
};

export type CatalogContentTypesOnWhichTagsCanBeAdded = 'database' | 'table' | 'column';

export type CatalogTagsBatchCreateParams = {
  readonly contentType: CatalogContentTypesOnWhichTagsCanBeAdded;
  readonly itemLuids: ReadonlyArray<string>;
  readonly tagsToAdd: ReadonlyArray<string>;
}

export type CatalogTagsBatchCreateRequestBody = {
  readonly tagBatch: {
    readonly tags: {
      readonly tag: ReadonlyArray<{
        readonly label: string;
      }>;
    };
    readonly contents: {
      readonly content: ReadonlyArray<{
        readonly contentType: CatalogContentTypesOnWhichTagsCanBeAdded;
        readonly id: string;
      }>;
    };
  };
}

function mapParamsToBody(params: CatalogTagsBatchCreateParams): CatalogTagsBatchCreateRequestBody {
  return {
    tagBatch: {
      tags: {
        tag: params.tagsToAdd.map(tag => ({
          label: tag
        })),
      },
      contents: {
        content: params.itemLuids.map(luid => ({
          contentType: params.contentType,
          id: luid,
        })),
      }
    }
  };
}

export async function callViaApiService(params: CatalogTagsBatchCreateParams) {
  return makeJsonRestApiRequest<CatalogTagsBatchCreateRequestBody, {}>({
    config: catalogTagsBatchCreateConfig,
    request: mapParamsToBody(params),
  });
}
